module.exports = __webpack_public_path__ + "img/2.14393037.png";